import axios from 'axios';

export const fetchHelloWorkJobs = async () => {
  try {
    const response = await axios.get('https://mysafari.safari-technologies.com/api/hellowork/offres');
    return response.data.Results || [];
  } catch (error) {
    console.error("Error fetching HelloWork jobs:", error.message);
    return [];
  }
};
